export function fireHTMLEvent(element, event) {
  let evt = document.createEvent('HTMLEvents');
  evt.initEvent('change', false, true);
  element.dispatchEvent(evt);
}
